"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCConfigStateChangeResponseT = exports.VRCConfigStateChangeResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const vrcconfig_recommended_values_js_1 = require("../../solarxr-protocol/rpc/vrcconfig-recommended-values.js");
const vrcconfig_validity_js_1 = require("../../solarxr-protocol/rpc/vrcconfig-validity.js");
const vrcconfig_values_js_1 = require("../../solarxr-protocol/rpc/vrcconfig-values.js");
/**
 * Sent every time the vrchat config state gets updated
 * used to display vrchat missconfig settings to the user
 */
class VRCConfigStateChangeResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsVRCConfigStateChangeResponse(bb, obj) {
        return (obj || new VRCConfigStateChangeResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsVRCConfigStateChangeResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new VRCConfigStateChangeResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    isSupported() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    validity(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new vrcconfig_validity_js_1.VRCConfigValidity()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    state(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new vrcconfig_values_js_1.VRCConfigValues()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    recommended(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new vrcconfig_recommended_values_js_1.VRCConfigRecommendedValues()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startVRCConfigStateChangeResponse(builder) {
        builder.startObject(4);
    }
    static addIsSupported(builder, isSupported) {
        builder.addFieldInt8(0, +isSupported, +false);
    }
    static addValidity(builder, validityOffset) {
        builder.addFieldOffset(1, validityOffset, 0);
    }
    static addState(builder, stateOffset) {
        builder.addFieldOffset(2, stateOffset, 0);
    }
    static addRecommended(builder, recommendedOffset) {
        builder.addFieldOffset(3, recommendedOffset, 0);
    }
    static endVRCConfigStateChangeResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new VRCConfigStateChangeResponseT(this.isSupported(), (this.validity() !== null ? this.validity().unpack() : null), (this.state() !== null ? this.state().unpack() : null), (this.recommended() !== null ? this.recommended().unpack() : null));
    }
    unpackTo(_o) {
        _o.isSupported = this.isSupported();
        _o.validity = (this.validity() !== null ? this.validity().unpack() : null);
        _o.state = (this.state() !== null ? this.state().unpack() : null);
        _o.recommended = (this.recommended() !== null ? this.recommended().unpack() : null);
    }
}
exports.VRCConfigStateChangeResponse = VRCConfigStateChangeResponse;
class VRCConfigStateChangeResponseT {
    constructor(isSupported = false, validity = null, state = null, recommended = null) {
        this.isSupported = isSupported;
        this.validity = validity;
        this.state = state;
        this.recommended = recommended;
    }
    pack(builder) {
        const validity = (this.validity !== null ? this.validity.pack(builder) : 0);
        const state = (this.state !== null ? this.state.pack(builder) : 0);
        const recommended = (this.recommended !== null ? this.recommended.pack(builder) : 0);
        VRCConfigStateChangeResponse.startVRCConfigStateChangeResponse(builder);
        VRCConfigStateChangeResponse.addIsSupported(builder, this.isSupported);
        VRCConfigStateChangeResponse.addValidity(builder, validity);
        VRCConfigStateChangeResponse.addState(builder, state);
        VRCConfigStateChangeResponse.addRecommended(builder, recommended);
        return VRCConfigStateChangeResponse.endVRCConfigStateChangeResponse(builder);
    }
}
exports.VRCConfigStateChangeResponseT = VRCConfigStateChangeResponseT;
